module.exports = __webpack_public_path__ + "assets/356c61041d30223f74711e79c8bb8ae9.js";